import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	warningTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.state-screen.warning-title',
		defaultMessage: 'Something went wrong',
		description: 'Warning screen title in dependency report',
	},
	warningText: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.state-screen.warning-text',
		defaultMessage:
			'You’ve encountered a bug, and your dependency report couldn’t be loaded as a result. Add a filter to try again.',
		description: 'Description on the warning screen in dependency report',
	},
	noDependencyTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.state-screen.no-dependency-title',
		defaultMessage: 'Add a dependency to get started',
		description: 'Empty screen title in dependency report when no dependency exists',
	},
	noDependencyText: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.state-screen.no-dependency-text',
		defaultMessage:
			'Dependencies show in what order your tasks need to be completed. Use the <strong>Add dependency</strong> button in the upper right to get started.',
		description: 'Description on the empty screen in dependency report when no dependency exists',
	},
	iphLink: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.state-screen.iph-link',
		defaultMessage: 'What is the dependencies view of your plan?',
		description: 'Link to the IPH article about dependencies report',
	},
	tooManyFiltersTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.state-screen.too-many-filters-title',
		defaultMessage: 'No matching issues found',
		description: 'Empty screen title in dependency report when too many filters selected',
	},
	tooManyFiltersText: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.state-screen.too-many-filters-text',
		defaultMessage: 'Adjust your filters and try again.',
		description:
			'Description text on the empty screen in dependency report  when too many filters selected',
	},
});
